/* KitchenBuildr collection filter bar.
   Pills filter through kb-facets.js (data-kbf-link), so this only handles
   "Show all", and hides the sidebar groups the bar already covers. */
(function () {
  'use strict';

  function qsa(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function labelsInBar() {
    return qsa('[data-kbfb] .kbfb__label').map(function (el) {
      return el.textContent.trim().toLowerCase();
    });
  }

  /* The Type and Width groups live in the bar, so drop them from the sidebar panel */
  function dedupeSidebar() {
    var bar = document.querySelector('[data-kbfb]');
    if (!bar || bar.dataset.dedupe === 'off') return;
    var labels = labelsInBar();
    if (!labels.length) return;
    qsa('[data-kbf-group]').forEach(function (group) {
      var label = group.querySelector('.kbf-group__label');
      if (!label) return;
      var text = label.textContent.trim().toLowerCase();
      var match = labels.indexOf(text) !== -1;
      group.hidden = match;
      group.classList.toggle('kbfb-hidden-group', match);
    });
    if (bar.dataset.dedupeCats === 'true') {
      qsa('.kbf-cats').forEach(function (list) { list.hidden = true; });
    }
  }

  /* Never leave the selected pill hidden behind "Show all" */
  function revealActive() {
    qsa('[data-kbfb-row].is-collapsed').forEach(function (row) {
      var active = row.querySelector('.kbfb__pill.is-active:not([href$="#"])');
      if (!active) return;
      var pills = row.querySelector('.kbfb__pills');
      var clipped = false;
      if (pills && pills.clientHeight > 0) {
        var box = pills.getBoundingClientRect();
        var pill = active.getBoundingClientRect();
        clipped = pill.bottom > box.bottom + 2 || pill.top < box.top - 2;
      }
      var hidden = active.offsetParent === null || clipped;
      if (hidden) expand(row, true);
    });
  }

  function expand(row, open) {
    row.classList.toggle('is-collapsed', !open);
    var btn = row.querySelector('[data-kbfb-more]');
    if (btn) btn.textContent = open ? btn.dataset.less : btn.dataset.more;
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-kbfb-more]');
    if (!btn) return;
    e.preventDefault();
    var row = btn.closest('[data-kbfb-row]');
    if (!row) return;
    expand(row, row.classList.contains('is-collapsed'));
  });

  /* Re-apply after an AJAX filter update (kb-facets re-renders the results area) */
  function refresh() { dedupeSidebar(); revealActive(); }

  document.addEventListener('kb:collection:updated', refresh);
  document.addEventListener('shopify:section:load', refresh);
  window.addEventListener('resize', revealActive);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', refresh);
  else refresh();
})();